import {
  StaticDetailActionTypes,
  SearchRoomActionTypes,
  DayUseActionTypes,
  MultiRoomCartActionTypes,
  AlternateDatesActionTypes,
  HotelierMediaActionTypes,
  SingleRoomActionTypes,
  DetailsActionTypes,
  GalleryReducerActionTypes,
  DetailsUnifSSRActionTypes,
} from './constants';

import {createAction} from '@stencil/hotels-types/src/type-guards';

export const updateSSRDetailsApiData = (data: Object) => {
  return createAction(DetailsUnifSSRActionTypes.UPDATE_SSR_ALL_API_DATA, data);
};

export const updateDetailsStaticFetchStatus = ({status}: {status: object}) => {
  return createAction(StaticDetailActionTypes.UPDATE_DETAILS_STATIC_FETCH_STATUS, {status});
};

export const updateDetailsStaticDataReviews = ({data}: {data: object}) => {
  return createAction(StaticDetailActionTypes.UPDATE_DETAILS_STATIC_DATA_REVIEWS, {data});
};

export const updateDetailsStaticData = ({data}: {data: object}) => {
  return createAction(StaticDetailActionTypes.UPDATE_DETAILS_STATIC_DATA, {data});
};

export const updateSeoReviewData = actionData => {
  return createAction(StaticDetailActionTypes.UPDATE_SEO_REVIEWS_DATA, actionData);
};

export const resetStaticData = () => {
  return createAction(StaticDetailActionTypes.RESET_DETAILS_DATA, {});
};

/* ------- Search Room Actions ------- */

export const updateSearchRoomFetchStatus = ({status}: {status: object}) => {
  return createAction(SearchRoomActionTypes.UPDATE_SEARCH_ROOM_FETCH_STATUS, {status});
};

export const updateSelectedRoomData = (selectedRoomData: any) => {
  return createAction(SearchRoomActionTypes.UPDATE_SELECTED_ROOM_DATA, {selectedRoomData});
};

export const updateSearchRoomData = ({data}: {data: object}) => {
  return createAction(SearchRoomActionTypes.UPDATE_SEARCH_ROOM_DATA, {data});
};

export const resetSearchRoomData = () => {
  return createAction(SearchRoomActionTypes.RESET_SEARCH_ROOM_DATA, {});
};

export const updateDetailsPageConfigAction = ({
  actionData,
}: {
  actionData: {appliedFiltersInUrl: []};
}) => {
  return createAction(SearchRoomActionTypes.UPDATE_DETAILS_CONFIG, actionData);
};

/* ------- Multi Room Cart Actions ------- */

export const updateDetailsCartRequestData = actionData => {
  return createAction(MultiRoomCartActionTypes.UPDATE_DETAILS_CART_REQUEST_DATA, {actionData});
};

export const updateDetailsCartResponseData = actionData => {
  return createAction(MultiRoomCartActionTypes.UPDATE_DETAILS_CART_RESPONSE_DATA, actionData);
};

export const updateDetailsCartUIData = actionData => {
  return createAction(MultiRoomCartActionTypes.UPDATE_DETAILS_CART_UI_DATA, {actionData});
};

export const setActivePayModeInCart = actionData => {
  return createAction(MultiRoomCartActionTypes.SET_ACTIVE_PAY_MODE_IN_CART, actionData);
};

export const updateArcReachedForRoomCode = actionData => {
  return createAction(MultiRoomCartActionTypes.SET_ARC_REACHED_WITH_ROOM_CODE, {actionData});
};

export const updateDetailsCartFetchStatus = ({isLoading}: {isLoading: boolean}) => {
  return createAction(MultiRoomCartActionTypes.UPDATE_DETAILS_CART_FETCH_STATUS, {isLoading});
};

export const updateAppliedFilters = actionData => {
  return createAction(MultiRoomCartActionTypes.SET_DETAILS_APPLIED_FILTER_LIST, {actionData});
};

export const resetMultiRoomCartData = () => {
  return createAction(MultiRoomCartActionTypes.RESET_MULTI_ROOM_CART_DATA, {});
};

export const updateMultiRestaurantActiveAccordion = actionData => {
  return createAction(MultiRoomCartActionTypes.SET_MULTIRESTAURANT_ACTIVE_ACCORDION, actionData);
};

export const updateCurrentRoom = actionData => {
  return createAction(MultiRoomCartActionTypes.UPDATE_CURRENT_ROOM, actionData);
};

/* ------- Alternate Dates API Actions ------- */

export const updateAlternateDatesFetchStatus = ({status}: {status: object}) => {
  return createAction(AlternateDatesActionTypes.UPDATE_ALTERNATE_DATES_FETCH_STATUS, {status});
};

export const updateAlternateDatesData = ({data, hotelId}: {data: object; hotelId?: number}) => {
  return createAction(AlternateDatesActionTypes.UPDATE_ALTERNATE_DATES_DATA, {data, hotelId});
};

export const updateAlternateDatesHotelId = ({hotelId}: {hotelId: number}) => {
  return createAction(AlternateDatesActionTypes.UPDATE_ALTERNATE_DATES_HOTEL_ID, {hotelId});
};

/* ------- Hotelier Media API Actions ------- */

export const setSelectedRatePlanAction = actionData => {
  return createAction(SingleRoomActionTypes.setSelectedRatePlan, actionData);
};

export const updateDetailsSeoFlagAction = actionData => {
  return createAction(DetailsActionTypes.UPDATE_DETAILS_SEO_FLAG, actionData);
};

export const updateDetailsAltAccoFlagAction = actionData => {
  return createAction(DetailsActionTypes.UPDATE_DETAILS_ALTACCO_FLAG, actionData);
};

/*--------------------- Day Use API Actions --------------------------*/

export const updateSlotsFetchStatus = ({status}: {status: object}) => {
  return createAction(DayUseActionTypes.UPDATE_SLOTS_STATUS_DATA, {status});
};

export const updateSlotsData = ({data}: {data: object}) => {
  return createAction(DayUseActionTypes.UPDATE_SLOTS_DATA, {data});
};

export const resetSlotsData = () => {
  return createAction(DayUseActionTypes.RESET_SLOTS_DATA, {});
};

export const updateGalleryPopupType = actionData => {
  return {
    type: GalleryReducerActionTypes.UPDATE_GALLERY_POPUP_TYPE,
    actionData,
  };
};

/* ------- Action Types ------- */
export type DetailsAction =
  | ReturnType<typeof updateSSRDetailsApiData>
  | ReturnType<typeof updateDetailsStaticFetchStatus>
  | ReturnType<typeof updateDetailsStaticDataReviews>
  | ReturnType<typeof updateDetailsStaticData>
  | ReturnType<typeof updateSeoReviewData>
  | ReturnType<typeof resetStaticData>
  | ReturnType<typeof updateSearchRoomFetchStatus>
  | ReturnType<typeof updateSelectedRoomData>
  | ReturnType<typeof updateSearchRoomData>
  | ReturnType<typeof resetSearchRoomData>
  | ReturnType<typeof updateDetailsPageConfigAction>
  | ReturnType<typeof updateDetailsCartRequestData>
  | ReturnType<typeof updateDetailsCartResponseData>
  | ReturnType<typeof updateDetailsCartUIData>
  | ReturnType<typeof setActivePayModeInCart>
  | ReturnType<typeof updateArcReachedForRoomCode>
  | ReturnType<typeof updateDetailsCartFetchStatus>
  | ReturnType<typeof updateAppliedFilters>
  | ReturnType<typeof resetMultiRoomCartData>
  | ReturnType<typeof updateMultiRestaurantActiveAccordion>
  | ReturnType<typeof updateCurrentRoom>
  | ReturnType<typeof updateAlternateDatesFetchStatus>
  | ReturnType<typeof updateAlternateDatesData>
  | ReturnType<typeof updateAlternateDatesHotelId>
  | ReturnType<typeof setSelectedRatePlanAction>
  | ReturnType<typeof updateDetailsSeoFlagAction>
  | ReturnType<typeof updateDetailsAltAccoFlagAction>
  | ReturnType<typeof updateSlotsFetchStatus>
  | ReturnType<typeof updateSlotsData>
  | ReturnType<typeof updateGalleryPopupType>
  | ReturnType<typeof resetSlotsData>;
